import { Box } from '@mui/material';

import { PanelWrapper } from '../panels/panelWrapper';

export const FiltersPanelWrapper = ({
  title,
  subtitle,
  onBack,
  children,
  onClose,
}: React.PropsWithChildren<{
  title: string | undefined;
  subtitle?: string;
  onBack?: () => void;
  onClose?: () => void;
}>) => {
  return (
    <Box
      sx={{
        backgroundColor: 'var(--mui-palette-background-paper)',
        borderRadius: '16px',
        margin: '40px',
        height: 'calc(100% - 80px)',
      }}
    >
      <PanelWrapper
        header={{
          title,
          subtitle,
          onClose,
          onBack,
          alignTitles: true,
          hideBorder: true,
        }}
      >
        {children}
      </PanelWrapper>
    </Box>
  );
};
